import { useJobillaOrgId } from '@/hooks'
import { logger } from '@/ui'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../rapid-ui'
import { useEditorContext } from '../editor-provider'
import { EditChatPanel } from './chat-panel'

export const EditingEditArea = memo(function EditingEditArea({ campaignId }: { campaignId: string }) {
	const { t } = useTranslation('common')
	const { shellRef } = useEditorContext()
	const jobillaOrgId = useJobillaOrgId()

	const handleContinue = () => {
		if (!shellRef) {
			return
		}

		logger.track('Editor: Continued to review', {
			data: {
				campaign_id: campaignId,
				organisation_id: jobillaOrgId,
				company: jobillaOrgId,
			},
		})

		shellRef.current?.moveToReviewStep()
	}

	return (
		<div className="flex flex-col h-full w-full">
			{/* Chat panel - takes available space, scrolls internally */}
			<div className="flex-1 min-h-0">
				<EditChatPanel
					campaignId={campaignId}
				/>
			</div>

			{/* Continue button - pinned to bottom */}
			<div className="shrink-0 w-full flex justify-center py-4">
				<Button
					type="green"
					postfix="arrow"
					onClick={handleContinue}
				>
					{t('editor.placeholders.continue')}
				</Button>
			</div>
		</div>
	)
})
